import Common from './routes/common'
import CommunityServiceSwiper from './components/communityServiceSwiper'
import PostVoting from './components/postVoting'
import Single from './routes/single'
import Review from './routes/review'
import Releases from './routes/releases'

document.addEventListener('DOMContentLoaded', () => {
  // load on every page
  new Common()

  // Community Service
  if (document.getElementById('prp-cs-swiper')) {
    const cs = new CommunityServiceSwiper()
    cs.init()
  }

  // Post Voting
  if (document.body.classList.contains('enable-post-voting')) {
    const postVoting = new PostVoting()
    postVoting.init()
  }

  // Single
  if (document.body.classList.contains('wp-singular')) {
    new Single()
  }

  // Review
  if (document.body.classList.contains('is-review')) {
    new Review()
  }

  // Releases
  if (document.body.classList.contains('releases')) {
    const releases = new Releases()
    releases.init()
  }
})
